import React, { useState, useEffect } from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import "../styles/pages/about_page.css";

import ChevronRightIcon from "../assets/icons/chevron-right.svg";
import AboutCompanySectionImg from "../assets/images/about_company_section_image.png";
import AboutPageBgImg from "../assets/images/about_page_bg_image.png";
import CarImg from "../assets/images/car_img.png";
import DevelopmentSectionImg from "../assets/images/development_section_image.png";

import useAutoScroll from "../hooks/useAutoScroll.js";
import Loader from "../components/Loader.jsx";
import { fetchAboutCompanyGallery } from "../services/apiService.js";

import { IMAGE_BASE_URL } from "../services/imageConfig.js";

const AboutPage = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const {
    containerRef: galleryRef,
    handleMouseEnter: handleGalleryMouseEnter,
    handleMouseLeave: handleGalleryMouseLeave,
    handleTouchStart: handleGalleryTouchStart,
    handleTouchEnd: handleGalleryTouchEnd,
  } = useAutoScroll({ speed: 2 });

  useEffect(() => {
    const fetchImagesData = async () => {
      try {
        const data = await fetchAboutCompanyGallery();
        const updatedData = data.flatMap((item) =>
          item.pathToImages.map((path, index) => ({
            id: `${item.id}-${index}`,
            url: IMAGE_BASE_URL + path,
          }))
        );
        setGalleryImages(updatedData);
      } catch (error) {
        console.error("Ошибка при получении галереи:", error);
      }
    };

    fetchImagesData();
  }, []);

  useEffect(() => {
    if (galleryImages.length === 0) {
      setImagesLoaded(true);
      setIsDataLoading(false);
      return;
    }
    const imageUrls = galleryImages.map((item) => item.url);
    Promise.all(
      imageUrls.map(
        (url) =>
          new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = resolve;
            img.onerror = resolve;
          })
      )
    ).then(() => {
      setImagesLoaded(true);
      setIsDataLoading(false);
    });
  }, [galleryImages]);

  if (isDataLoading || !imagesLoaded) {
    return (
      <div className="loader-wrapper">
        <Loader />
        <p className="loading-text">Загрузка...</p>
      </div>
    );
  }

  return (
    <div className="about-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">Главная</a>
        <img src={ChevronRightIcon} alt="Chevron" className="nav-chevron-icon" />
        <span className="nav-link">О компании</span>
      </nav>
      <div className="about-section">
        <div className="about-section-content">
          <div className="about-text-block">
            <h2 className="white-page-title">О компании</h2>
            <p className="about-main-paragraph">
              Сеть АЗС "Bishkek Petroleum" (ОсОО «ШНОС») - отечественная нефтяная компания, поставляющая и реализующая высококачественные нефтепродукты.
            </p>
            <p className="about-paragraph">
              "Bishkek Petroleum" ставит перед собой задачу поднять на новый уровень обслуживание потребителей – водителей: создать сеть автозаправочных комплексов, которая позволит не только заправиться в любой точке северной части Кыргызстана, а также обеспечит высокий уровень сервиса и широкий ассортимент услуг и товаров на АЗС.
            </p>
            <p className="about-paragraph">
              Свою деятельность ОсОО «ШНОС» начало в 1998 году. С конца 2012, ОсОО «ШНОС» осуществляет свою деятельность под брендом "Bishkek Petroleum".
            </p>
          </div>
          <img
            src={AboutCompanySectionImg}
            alt="About Company"
            className="about-image"
          />
        </div>
      </div>
      <img
        src={AboutPageBgImg}
        alt="About page background"
        className="about-page-bg-image"
      />
      <div className="about-page-content">
        <div className="development-section">
          <img
            src={DevelopmentSectionImg}
            alt="Development and Modernization"
            className="development-section-image"
          />
          <div className="development-text-block-wrapper">
            <div className="development-text-block">
              <h2 className="gradient-page-title">Развитие и модернизация</h2>
              <p className="development-paragraph">
                На сегодняшний день компания владеет обширной сетью АЗС, которая расположена в г. Бишкек, Чуйской и Иссык-Кульской областях.
              </p>
              <p className="development-paragraph">
                Компания ведет работу по ре-брэндингу и автоматизации автозаправочных комплексов согласно мировым стандартам качества и безопасности.
              </p>
              <p className="development-paragraph">
                Приоритетными направлениями являются внедрение экологически чистых технологий и расширение ассортимента сопутствующих услуг, что позволяет обеспечивать клиентов не только топливом высокого качества, но и создавать комфортные условия для каждого посетителя.
              </p>
            </div>
          </div>
        </div>
        <div className="beyond-basic-services-section">
          <div className="bbs-text-block">
            <h2 className="gradient-page-title">Помимо базовых услуг</h2>
            <p className="bbs-paragraph">
              Высококачественное топливо, бензин марок B-power, АИ-92, АИ – 95, АИ – 100, летнее и зимнее дизельное топливо. Внедряется экологичный и экономичный альтернативный вид топлива - СУГ (сжиженный углеводородный газ)
            </p>
            <p className="bbs-paragraph">
              Заправочные станции предлагают широкий спектр услуг, необходимых не только автомобилям, но и их владельцам.
            </p>
            <p className="bbs-paragraph">
              На АЗС компании Bishkek Petroleum существуют круглосуточные магазины, где клиенты могут приобрести ассортимент автотоваров, продуктов питания, напитков, а также бодрящий кофе.
            </p>
          </div>
          <img src={CarImg} alt="Car illustration" className="bbs-img" />
        </div>
        <div className="gallery-section">
          <div
            className="gallery-container"
            ref={galleryRef}
            onMouseEnter={handleGalleryMouseEnter}
            onMouseLeave={handleGalleryMouseLeave}
            onTouchStart={handleGalleryTouchStart}
            onTouchEnd={handleGalleryTouchEnd}
          >
            {galleryImages.map((image) => (
              <div className="gallery-item" key={image.id}>
                <img
                  src={image.url}
                  alt={`Gallery ${image.id}`}
                  className="gallery-item-img"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="self-service-section">
          <h2 className="gradient-page-title">
            Мы развиваемся и открыты для сотрудничества!
          </h2>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
